import bn_IN from './bn_IN.json';
import en_US from './en_US.json';
import es_SP from './es_SP.json';
import hn_IN from './hn_IN.json';

export const translations = {
  'en-US': en_US,
  'es-SP': es_SP,
  'bn-IN': bn_IN,
  'hn-IN': hn_IN
};
